import type { FlowAccumulator, Param } from '../model'

export const asyncFlow =
  <Response>(...fns: any[]) =>
  async (initialValue?: FlowAccumulator): Promise<Response> => {
    let accumulator = initialValue

    for (const fn of fns) {
      accumulator = await fn(accumulator)
    }

    return accumulator as Response
  }

export const formDataFromJSON = <T extends Param>(object: T) => {
  const formData = new FormData()
  Object.keys(object).forEach((key) => {
    const value = object[key as keyof T]
    formData.append(key, value)
  })
  return formData
}
